import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { t } from 'react-switch-lang';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// eslint-disable-next-line import/no-unresolved
import { faExternalLink } from '@awesome.me/kit-299dd46f46/icons/classic/light';

function ContactFormHeader({ brand, lang, widgetMode }) {
  const isMobile = window.location.href.includes('mobileapp');
  const showExternalLink = widgetMode && !isMobile;
  const externalLinkLabel = t('LinkDescription_Contact_External_Link', null, lang);

  const renderTooltip = () => (
    <Tooltip id="contact-external-link-tooltip">
      {externalLinkLabel}
    </Tooltip>
  );

  return (
    <div className="contact-form-title-link-flex">
      <h1 className="contact-us-header">{t('General_Contact_Us')}</h1>
      {showExternalLink && (
        <OverlayTrigger
          placement="top"
          rootClose
          delay={{ show: 250, hide: 250 }}
          overlay={renderTooltip}
        >
          <a
            href={`/${brand}/${lang}/contactus`}
            target="_blank"
            rel="noreferrer"
            className="contact-widget-ext-link"
            aria-label={externalLinkLabel}
          >
            <FontAwesomeIcon icon={faExternalLink} className="contact-widget-link-icon" />
          </a>
        </OverlayTrigger>
      )}
    </div>
  );
}

export default ContactFormHeader;
